import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from '@mui/icons-material/Send';
import Snackbar from '@mui/material/Snackbar';
import { Box, Button, Alert } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

import { RequestButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box'

import { postData } from "../func/api";
import { useAuth } from "../contexts/AuthContext";
import { BaseDialog } from "./base_dialog";
import FullScreenCircularLoading from '../components/fullscreen_circular_loading';

const REPORT_CONFIGS = {
    initial: {
        api: "api/post_send_first_approval",
        status: 13,
        path: "first_report"
    },
    primary: {
        api: "api/post_send_primary_inspection",
        status: 16,
        path: "primary_inspection"
    },
    secondary: {
        api: "api/post_send_secondary_inspection",
        status: 19,
        path: "secondary_inspection"
    }
};

export default function SendReportDialog({ uuid, earthquake_uuid, taskStatus, setTaskStatus, disabled, type, department }) {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [uploadMessage, setUploadMessage] = useState("");
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [loading, setLoading] = useState(false);
    const [isSending, setIsSending] = useState(false); // 送信状態を管理

    const handleClickOpen = () => {
        setOpen(true);
        setErrorMessage("");
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendReport = async () => {
        if (isSending) return; // 送信中の場合は処理をスキップ

        try {
            const payload = {
                earthquake_uuid: earthquake_uuid,
                uuid: uuid,
                user_uuid: currentUser.id,
                user_name: currentUser.name,
                user_department: department
            };

            setLoading(true);
            setIsSending(true); // 送信開始
            handleClose();

            const config = REPORT_CONFIGS[type] || REPORT_CONFIGS.secondary;

            await postData(config.api, payload);
            setTaskStatus(config.status);
            setUploadMessage("報告書を送付しました！");
            setAlertSeverity("success");
            setAlertOpen(true);

            // 数秒後に遷移
            setTimeout(() => {
                window.location.href = `/${config.path}/${earthquake_uuid}`;
            }, 2000);

        } catch (error) {
            console.error("送付に失敗しました:", error);
            setAlertSeverity("error");
            setUploadMessage("送付に失敗しました。もう一度お試しください。");
            setAlertOpen(true);
            setIsSending(false); // エラー時は送信状態をリセット
        } finally {
            setLoading(false);
        }
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
        // 成功時のアラートが閉じられた場合のみ送信状態をリセット
        if (alertSeverity === "error") {
            setIsSending(false);
        }
    };

    return (
        <>
            <BoxSpaceCenter>
                <RequestButton
                    startIcon={<SendIcon />}
                    onClick={handleClickOpen}
                    disabled={disabled || isSending} // 送信中も無効化
                >
                    報告書送付
                </RequestButton>

                <BaseDialog
                    open={open}
                    onClose={handleClose}
                    title="報告書送付"
                    message={"報告書を送付します。\nよろしいですか？"}
                    onConfirm={handleSendReport}
                    confirmText='送信'
                    cancelText='キャンセル'
                />

                {loading && <FullScreenCircularLoading loading={loading} />}

            </BoxSpaceCenter>

            {uploadMessage && (
                <Snackbar
                    open={alertOpen}
                    autoHideDuration={3000} // 3秒に延長
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={handleAlertClose}
                >
                    <Alert severity={alertSeverity} onClose={handleAlertClose}>
                        {uploadMessage}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
}